import type { BondPaymentType, BondsAndDividendsEntry } from "@eu.mdotm.api/sphere";

export type BondDividendRow = {
	/** ISO date string */
	date: string | null;
	name: string;
	type: string;
	/** Coupon rate as a denormalized percentage (0-100). */
	couponRate: number | null;
	/** Delta cash as a denormalized percentage (0-100); on a quantities portfolio, an amount in the base currency. */
	deltaCash: number | null;
};

/** Human-readable labels for each cash-flow event type. Shared by the widget and the report builder. */
const bondCashFlowTypeLabels: Record<BondPaymentType, string> = {
	COUPON: "Coupon",
	DIVIDEND: "Dividend",
	MATURITY: "Maturity",
};

/** Maps a raw cash-flow entry from the API into a display row. */
export function toBondDividendRow(entry: BondsAndDividendsEntry): BondDividendRow {
	return {
		date: entry.date ?? null,
		name: entry.name ?? "",
		type: entry.type != null ? bondCashFlowTypeLabels[entry.type] : "",
		couponRate: entry.couponRate ?? null,
		deltaCash: entry.deltaCash ?? null,
	};
}
